export enum MonitorType {
	AmazonBilling = 'AMAZONBILLING',
	Azure = 'AZURE',
	AzureBilling = 'AZUREBILLING',
	Connectivity = 'CONNECTIVITY',
	Container = 'CONTAINER',
	Database = 'DATABASE',
	DbWatch = 'DBWATCH',
	EatonUps = 'EATONUPS',
	External = 'EXTERNAL',
	FileSearch = 'FILESEARCH',
	Groovy = 'GROOVY',
	HyperV = 'HYPERV',
	IbmSvc = 'IBMSVC',
	Icinga = 'ICINGA',
	InterfaceTraffic = 'INTERFACETRAFFIC',
	LinuxServices = 'LINUXSERVICES',
	Log = 'LOGMONITOR',
	MailGateway = 'MAILGTW',
	Metric = 'METRICMONITOR',
	Modbus = 'MODBUS',
	MsCluster = 'MSCLUSTER',
	Nagios = 'NAGIOS',
	NimSoft = 'NIMSOFT',
	Processes = 'PROCESSES',
	ProcessesNew = 'PROCESSMONITOR',
	Prtg = 'PRTG',
	RemoteSeries = 'REMOTEISERIES',
	RemoteSystem = 'REMOTESYSTEM',
	Script = 'SCRIPT',
	Snmp = 'SNMP',
	SnmpTrap = 'SNMPTRAP',
	SolarWinds = 'SOLARWINDS',
	System = 'SYSTEM',
	SystemNew = 'SYSTEMNEW',
	Url = 'URL',
	VmWare = 'VMWARE',
	Vmm = 'VMM',
	Webhook = 'WEBHOOK',
	WindowsEvents = 'WINEVENTS',
	WindowsServices = 'WINSERVICE',
	XenServer = 'XEN_SERVER',
}

export enum MonitorUiType {
	Web = 'WEB',
	Annotated = 'ANNOTATED',
	Vaadin = 'VAADIN'
}
